import { Component, OnInit, HostListener } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { BaseAPIService } from '@app/Services/api.base.service';
import { label } from '@app/constants/labels';
import { QdsSelect } from '@quartzds/core-angular'
import { I18nService } from '@app/core/i18n.service';

@Component({
  selector: 'app-terms',
  standalone: false,
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent implements OnInit {

  public language: string;
  termsandcondition: boolean = false;
  privacyandpolicy: boolean = false;
  // languageSelected: boolean = false;
  labels= label;
  isAcceptTermsEnabled: boolean = false;
  selectedLanguage: string = 'en-US'; // or 'en' depending on your language codes
  languageSelected: boolean = true; // Set to true since English is pre-selected
  constructor(private i18nService: I18nService, public activeModal: NgbActiveModal, public auth: AuthenticationService, private readonly baseService: BaseAPIService) { }

  ngOnInit(): void {
    this.language = localStorage.getItem('language');
    // this.languageSelected = !!this.language; // Set to true if language already exists
    console.log('Current language:', this.language);

    // Listen for browser back/forward navigation
    window.addEventListener('popstate', this.onPopState);
  }

  ngOnDestroy(): void {
    window.removeEventListener('popstate', this.onPopState);
  }

  onPopState = () => {
    this.isAcceptTermsEnabled = false;
  }

  public DeclineTerms() {
    this.auth.isTermsAccepted = false;
    this.auth.logout();
  }
  public AcceptTerms() {
    this.baseService.PatchWithHeaders('/User/UpdateTermAccepted', {}, {}).subscribe((result: Boolean) => {
      this.auth.isTermsAccepted = true;
      this.activeModal.close('Close click');
      // this.auth.UpdateRbacDetails(this.auth.context);
      // this.auth.router.navigate(['/role-selection']);
    });
  }

  // public selectRole(role: string) {
  //   console.log('Selected role:', role);
  //   this.isAcceptTermsEnabled = true;
  // }

  setLanguage(event: any) {
    console.log('Language change event:', event);
    const languageCode = event.detail?.value || event.target?.value;
    console.log('Selected language code:', languageCode);
    if (languageCode) {
      this.i18nService.language = languageCode;
      this.language = languageCode;
      this.languageSelected = true;
    }
  }

  get currentLanguage(): string {
    const sslang = this.i18nService.supportedLanguages.filter(item => item.code === this.i18nService.language);
    return sslang[0].name;
  }

  get languages(): any[] {
    return this.i18nService.supportedLanguages;
  }

}
